import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Sleeve } from '../../api/models';

export type TABLE_TYPE = Table<Sleeve>;

export const TABLE = 'sleeve';
const SCHEMA = 'sleeveId, sortId';

class SleeveDatabase implements DataRepository<Sleeve> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<Sleeve | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Sleeve, key: Key): Promise<Sleeve> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: Sleeve[]): Promise<Sleeve[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Sleeve[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const SleeveDB = new SleeveDatabase(db);
